import { INews } from '@/interfaces/categoryPage';
import { Slider } from '@pwskills/rachnaui';
import NewsCard from './NewsCard';

const NewsCards = ({ newsData }: { newsData: INews[] }) => {
  return (
    <Slider
      iconWrapperClass="!p-0 !mx-0"
      wrapperClass="flex flex-col gap-6"
      className="gap-4 medium:gap-6 flex justify-start"
      positionOfSliderInMobile="bottom"
    >
      {newsData?.map((item: INews) => (
        <NewsCard {...item} />
      ))}
    </Slider>
  );
};

export default NewsCards;
